import React from 'react';
import { Dialog, Button } from '../../../../components/ui';
import { ANALYTICS_COPY } from '../../constants/analyticsCopy';

export default function PinToDashboardDialog({ open, onPin, onSkip }) {
  return (
    <Dialog
      open={open}
      onClose={onSkip}
      title={ANALYTICS_COPY.pinDialogTitle}
      actions={
        <>
          <Button variant="outlined" onClick={onSkip}>
            {ANALYTICS_COPY.skipPin}
          </Button>
          <Button variant="contained" onClick={onPin}>
            {ANALYTICS_COPY.pinToDashboard}
          </Button>
        </>
      }
    >
      {ANALYTICS_COPY.pinDialogBody}
    </Dialog>
  );
}
